// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bar":"bar_82t5w","total":"total_wiQPq","nav":"nav_rtT8X"};